<template>
  <div>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          Do you smoke?
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.doSmoke.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': doSmokeState }"
                name="rd1"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.doSmoke.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': doSmokeState }"
                name="rd1"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr v-show="doSmoke != null && doSmoke == true">
    <b-row v-show="doSmoke != null && doSmoke == true">
      <b-col sm="8" class="row-align-left">
        <label for>
          Are you interested in quitting smoking?
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.quitSmoking.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': quitSmokingState }"
                name="rd2"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.quitSmoking.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': quitSmokingState }"
                name="rd2"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr v-show="doSmoke != null && doSmoke == true">
    <b-row v-show="doSmoke != null && doSmoke == true">
      <b-col sm="8" class="row-align-left">
        <label for>
          Would you like information on Smoking Cessation resource materials and programs?
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.smokingInfo.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': smokingInfoState }"
                name="rd3"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.smokingInfo.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': smokingInfoState }"
                name="rd3"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br/>
    <h5>Food Insecurity</h5>
    <hr>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          “Within the past 12 months, we worried whether our food would run out before we had money to buy more.”
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.foodRunOut.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': foodRunOutState }"
                name="rd4"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.foodRunOut.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': foodRunOutState }"
                name="rd4"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          “Within the past 12 months, the food we bought just didn`t last and we didn`t have money to get more.”
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.foodDidntLast.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': foodDidntLastState }"
                name="rd5"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.foodDidntLast.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': foodDidntLastState }"
                name="rd5"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="8" class="row-align-left">
        <label for>
          If the response to either statement is often true or sometimes true, the individual is identified as food insecure.  If true, ask the participant if he/she would like a list of food pantries/distribution centers available in their zip code area. 
        </label>
      </b-col>

      <b-col sm="4">
        <b-row>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.isFoodInsecure.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isFoodInsecureState }"
                name="rd6"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6">
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.isFoodInsecure.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': isFoodInsecureState }"
                name="rd6"
                :value="false"
              > No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <survey-nav :step="3" :ShowErrorMsg="showErrorMsg" @move-next="moveNext" @move-previous="movePrevious"></survey-nav>
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import surveyNav from "@/components/SurveyNav";

export default {
  name: "survey-step3",
  props: ["surveyData", "isValid"],
  data: () => ({
    doSmoke: null,
    quitSmoking: null,
    smokingInfo: null,
    foodRunOut: null,
    foodDidntLast: null,
    isFoodInsecure: null,
    showErrorMsg: false
  }),
  components: {
    surveyNav
  },
  validations: {
    doSmoke: {
      required
    },
    quitSmoking: {
      required
    },
    smokingInfo: {
      required
    },
    foodRunOut: {
      required
    },
    foodDidntLast: {
      required
    },
    isFoodInsecure: {
      required
    }
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) this.$emit("move-next");
      else{
        this.showErrorMsg = true;
        this.$v.$touch();
      } 
    },
     movePrevious() {
      this.$emit("move-previous");
    },
    onCreated() {      
      this.doSmoke = this.surveyData.DoSmoke;
      this.quitSmoking = this.surveyData.QuitSmoking;
      this.smokingInfo = this.surveyData.SmokingInfo;
      this.foodRunOut = this.surveyData.FoodRunOut;
      this.foodDidntLast = this.surveyData.FoodDidntLast;
      this.isFoodInsecure = this.surveyData.IsFoodInsecure;
    }
  },
  computed:{
    //Radio buttons must return a !result
    doSmokeState() {
      return this.$v.doSmoke.$dirty ? !this.$v.doSmoke.required : null;
    },
    quitSmokingState() {
      return this.$v.quitSmoking.$dirty ? !this.$v.quitSmoking.required : null;
    },
    smokingInfoState() {
      return this.$v.smokingInfo.$dirty ? !this.$v.smokingInfo.required : null;
    },
    foodRunOutState() {
      return this.$v.foodRunOut.$dirty ? !this.$v.foodRunOut.required : null;
    },
    foodDidntLastState() {
      return this.$v.foodDidntLast.$dirty ? !this.$v.foodDidntLast.required : null;
    },
    isFoodInsecureState() {
      return this.$v.isFoodInsecure.$dirty ? !this.$v.isFoodInsecure.required : null;
    }
  },
  watch: {
    doSmoke() {
      if (this.$v.doSmoke.required){
        this.surveyData.DoSmoke = this.doSmoke;   

        if (!this.doSmoke){
          this.quitSmoking = false;
          this.smokingInfo = false;
        }
      } 
    },
    quitSmoking() {
      if (this.$v.quitSmoking.required) this.surveyData.QuitSmoking = this.quitSmoking;
    },
    smokingInfo() {
      if (this.$v.smokingInfo.required) this.surveyData.SmokingInfo = this.smokingInfo;
    },
    foodRunOut() {
      if (this.$v.foodRunOut.required) this.surveyData.FoodRunOut = this.foodRunOut;
    },
    foodDidntLast() {
      if (this.$v.foodDidntLast.required) this.surveyData.FoodDidntLast = this.foodDidntLast;
    },
    isFoodInsecure() {
      if (this.$v.isFoodInsecure.required) this.surveyData.IsFoodInsecure = this.isFoodInsecure;
    }

  },
  created() {
    this.onCreated();
  }
};
</script>

<style scoped>
.invalid-radio-button{
  background-color: red;
}
</style>
